/**
 * Полный список ключей обучающих подсказок (storageKey каждого TutorialSpotlight).
 * Используется для миграции легаси-localStorage в синхронизируемый профиль и для
 * «Сбросить подсказки». Держать в синхроне с местами рендера TutorialSpotlight.
 */
export const ALL_TUTORIAL_KEYS = [
    'tut_home_v1',
    'tut_create_budget_v1',
    'tut_budget_cal_v1',
    'tut_dashboard_v1',
    'tut_add_tx_v1',
    'tut_budget_settings_v1',
    'tut_series_edit_v1',
    'tut_edit_series_v1',
    'import_tut_v3',
];
